export default __webpack_public_path__ + "static/media/1-4-4.9c4aeb6f.jpg";